import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { func_validation } from 'functions';

import 'assets/scss/components/layout/dropdownLayout.scss';



export function DropdownLayout(props) {
    const { className, 
            overviewClassName, overviewContentClassName, overviewIconClassName, 
            dropdownDetailClassName,
            overviewDisplay, dropdownDetailDisplay, isDropdownIconRequired, isCursorHidden } = props;

    // Validate props
    let overviewDisplay_formatted = func_validation.isNotNullUndefined(overviewDisplay)? overviewDisplay:"";
    let dropdownDetailDisplay_formatted = func_validation.isNotNullUndefined(dropdownDetailDisplay)? dropdownDetailDisplay:"";

    // States
    const [isDetailDisplayVisible, setDetailDisplayVisibility] = useState(false);

    return (
        <div className={"component-dropdownLayout " + 
                        (className? className + " ":"")}>
            {/* Overview */}
            <div className={"component-dropdownLayout-overview " +
                            (isCursorHidden? "component-dropdownLayout_noCursor ":"") +
                            (overviewClassName? overviewClassName + " ":"")}
                onClick={() => { if (isDropdownIconRequired) setDetailDisplayVisibility(!isDetailDisplayVisible); }}
            >
                <div className={"component-dropdownLayout-overview-content " +
                                (overviewContentClassName? overviewContentClassName + " ":"")}>
                    {overviewDisplay_formatted}
                </div>

                {isDropdownIconRequired? (
                    <FontAwesomeIcon 
                        className={"component-dropdownLayout-overview-icon " + 
                                    (overviewIconClassName? overviewIconClassName + " ":"") +
                                    (isDetailDisplayVisible? "component-dropdownLayout-overview-icon_rotate ":"")} 
                        icon={faChevronDown}
                    />
                ):""}
            </div>

            {/* Detail */}
            {isDetailDisplayVisible? (
                <div className={"component-dropdownLayout-detail d-flex flex-wrap " + 
                                (dropdownDetailClassName? dropdownDetailClassName + " ":"")}>
                    {dropdownDetailDisplay_formatted}
                </div>
            ):""}
        </div>
    );
}